import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faMapMarkerAlt, faGraduationCap } from "@fortawesome/free-solid-svg-icons";

import "./styles/educationExperience.css";

const EducationExperience = () => {
	const educationExperiences = [
		{
			institution: "University of Toronto",
			degree: "MSc in Applied Computing",
			duration: "Sep 2021 - Dec 2022",
			location: "Toronto, Canada",
			logo: "./utoronto.png",
			description: "Focused on advanced computing applications with emphasis on machine learning and computational linguistics.",
			keywords: ["Computer Science", "Machine Learning", "Computational Linguistics", "Natural Language Processing"]
		},
		{
			institution: "Tsinghua University",
			degree: "BEng in Automation",
			duration: "Sep 2017 - Jun 2021",
			location: "Beijing, China",
			logo: "./tsinghua.png",
			description: "Comprehensive engineering program with focus on automation systems and control theory.",
			minor: "Innovation and Entrepreneurship of Artificial Intelligence",
			keywords: ["Computer Science", "Automation", "Control Theory", "Artificial Intelligence"]
		}
	];

	return (
		<div className="education-experience-container">
			{educationExperiences.map((education, index) => (
				<div className="education-experience-item" key={index}>
					<div className="education-experience-header">
						<div className="education-experience-logo">
							<img src={education.logo} alt={`${education.institution} logo`} />
						</div>
						<div className="education-experience-details">
							<h3 className="education-experience-institution">{education.institution}</h3>
							<h4 className="education-experience-degree">{education.degree}</h4>
							<div className="education-experience-meta">
								<div className="education-experience-duration">
									<FontAwesomeIcon icon={faCalendar} />
									<span>{education.duration}</span>
								</div>
								<div className="education-experience-location">
									<FontAwesomeIcon icon={faMapMarkerAlt} />
									<span>{education.location}</span>
								</div>
							</div>
						</div>
					</div>
					<div className="education-experience-content">
						<p className="education-experience-description">{education.description}</p>
						{education.minor && (
							<div className="education-minor">
								<strong>Minor:</strong> {education.minor}
							</div>
						)}
						{education.keywords && (
							<div className="education-keywords">
								<div className="keyword-tags">
									{education.keywords.map((keyword, keywordIndex) => (
										<span key={keywordIndex} className="keyword-tag">
											{keyword}
										</span>
									))}
								</div>
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	);
};

export default EducationExperience;